import Grid from "@material-ui/core/Grid"
import TextField from "@material-ui/core/TextField"
import React from "react"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import { useCreate } from "./hooks"

const MultipleCreate = () => {
    const {
        callback, cancelCallback,
        dialogData, disabled, modalTimeStr,
        text, handleChange,
    } = useCreate("multiple")
    return (
        <BoardConfirmModal
            title="创建预约"
            confirmCallback={callback}
            cancelCallback={cancelCallback}
            modalShow={dialogData.show}
            disabled={disabled}
        >
            <Grid container direction="column" justify="center">
                <div>{modalTimeStr}</div>
                <TextField
                    label="预约说明"
                    value={text}
                    onChange={handleChange}
                />
            </Grid>
        </BoardConfirmModal>
    )
}

export default MultipleCreate
